import './TerminosCondiciones.css';
import Navbar from '../Navbar/Navbar';

const TerminosCondiciones = () => {
  return (
    <>
      <Navbar />
      <div className="terminos-condiciones container">
        <h1>Términos y Condiciones de Arbatech Solutions para el uso de Lancaster</h1>

        <section>
          <h2>1. Introducción</h2>
          <p>Bienvenido a Arbatech Solutions. Estos términos y condiciones regulan el uso de nuestro producto Lancaster, una plataforma que permite automatizar llamadas e interacciones con clientes mediante inteligencia artificial, operar desde un CRM e integrar servicios de terceros como Google Calendar para la gestión de disponibilidad y citas. Al utilizar Lancaster, usted acepta estos términos y condiciones en su totalidad. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar el producto.</p>
        </section>

        <section>
          <h2>2. Definiciones</h2>
          <ul>
            <li><strong>"Arbatech Solutions"</strong>: Se refiere a la empresa desarrolladora y proveedora del producto Lancaster.</li>
            <li><strong>"Lancaster"</strong>: Plataforma desarrollada por Arbatech Solutions que permite automatizar interacciones con clientes, operar procesos desde un CRM y utilizar integraciones como Google Calendar.</li>
            <li><strong>"Usuario"</strong>: Se refiere a la persona o entidad que utiliza Lancaster.</li>
            <li><strong>"Contenido"</strong>: Se refiere a cualquier mensaje, información, texto, gráficos, fotos u otros materiales enviados, recibidos o almacenados a través de Lancaster.</li>
          </ul>
        </section>

        <section>
          <h2>3. Uso del Servicio</h2>
          <h3>3.1 Acceso y Uso</h3>
          <p>El acceso a Lancaster está sujeto a la creación de una cuenta y la aceptación de estos términos y condiciones. El Usuario debe proporcionar información veraz y precisa al registrarse.</p>

          <h3>3.2 Propósito del Uso</h3>
          <p>Lancaster debe utilizarse únicamente para fines legales y en conformidad con todas las leyes y regulaciones aplicables. Queda prohibido el uso del servicio para enviar mensajes no solicitados (spam) o contenido ilícito.</p>

          <h3>3.3 Responsabilidad del Usuario</h3>
          <p>El Usuario es responsable del contenido enviado a través de Lancaster y debe asegurarse de que dicho contenido no infrinja derechos de terceros, incluyendo derechos de propiedad intelectual.</p>

          <h3>3.4 Integraciones con Terceros</h3>
          <p>Al conectar servicios de terceros como Google Calendar, el Usuario autoriza a Lancaster a acceder y utilizar la información necesaria para consultar disponibilidad, administrar eventos o citas y sincronizar esa información dentro de la plataforma. El Usuario es responsable de contar con los permisos necesarios sobre las cuentas que conecte y podrá desconectar estas integraciones desde Lancaster cuando la funcionalidad esté disponible.</p>
        </section>

        <section>
          <h2>4. Privacidad y Protección de Datos</h2>
          <h3>4.1 Recopilación de Datos</h3>
          <p>Arbatech Solutions puede recopilar y utilizar datos del Usuario, del uso de Lancaster y de las integraciones autorizadas por el Usuario, como Google Calendar, para prestar el servicio, mejorar la plataforma y cumplir con obligaciones legales.</p>

          <h3>4.2 Confidencialidad</h3>
          <p>Arbatech Solutions se compromete a proteger la privacidad y confidencialidad de los datos del Usuario, implementando medidas de seguridad adecuadas para prevenir el acceso no autorizado.</p>
        </section>

        <section>
          <h2>5. Propiedad Intelectual</h2>
          <h3>5.1 Derechos de Propiedad</h3>
          <p>Todos los derechos de propiedad intelectual sobre Lancaster, incluidos los derechos de autor, marcas comerciales y patentes, pertenecen a Arbatech Solutions.</p>

          <h3>5.2 Licencia de Uso</h3>
          <p>Arbatech Solutions otorga al Usuario una licencia no exclusiva, no transferible y revocable para usar Lancaster de acuerdo con estos términos y condiciones.</p>
        </section>

        <section>
          <h2>6. Limitación de Responsabilidad</h2>
          <h3>6.1 Sin Garantías</h3>
          <p>Lancaster se proporciona "tal cual" y "según disponibilidad", sin garantías de ningún tipo, expresas o implícitas.</p>

          <h3>6.2 Exclusión de Responsabilidad</h3>
          <p>Arbatech Solutions no será responsable por daños directos, indirectos, incidentales, especiales o consecuentes que resulten del uso o la imposibilidad de usar Lancaster.</p>
        </section>

        <section>
          <h2>7. Modificaciones y Terminación</h2>
          <h3>7.1 Modificaciones</h3>
          <p>Arbatech Solutions se reserva el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones serán efectivas a partir de su publicación en el sitio web de Arbatech Solutions.</p>

          <h3>7.2 Terminación</h3>
          <p>Arbatech Solutions puede suspender o terminar el acceso del Usuario a Lancaster en cualquier momento y por cualquier motivo, incluyendo, pero no limitado a, el incumplimiento de estos términos y condiciones.</p>
        </section>

        <section>
          <h2>8. Ley Aplicable y Jurisdicción</h2>
          <p>Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes del país en el que Arbatech Solutions tenga su sede. Cualquier disputa que surja en relación con estos términos se someterá a la jurisdicción exclusiva de los tribunales competentes en dicha jurisdicción.</p>
        </section>

        <section className="footer">
          <h2>9. Contacto</h2>
          <p>Para cualquier pregunta o inquietud sobre estos términos y condiciones, por favor contáctenos en:</p>
          <p><strong>Arbatech Solutions</strong><br />Correo electrónico: <a href="mailto:bob.lozano@arbatech.io">bob.lozano@arbatech.io</a></p>
          <p>Fecha de última actualización: 21/07/2024</p>
        </section>
      </div>
    </>
  );
};

export default TerminosCondiciones;
